export default ({ app, $config, route, req }) => {
    //
    //
    // Add meta tags

    const meta = [];

    meta.push({
        property: 'og:url',
        content: 'https://lifeofhoudini.com',
    });

    meta.push({
        name: 'robots',
        content: 'all',
    });

    app.head.meta.push(...meta);
};
